import React, {
  createContext,
  useEffect,
  useRef,
  useState,
} from "react";

import { getColorTheme } from "../assets/colorTheme";


export const ThemeContext = createContext();

export const ThemeProvider = (props) => {
  const [currentTheme, setCurrentTheme] = useState("light");
  useEffect(() => {}, [localStorage.getItem("SAVED_BUNDLE_DETAILS")]);
  const currentThemeRef = useRef(null);
  currentThemeRef.current = currentTheme;

  useEffect(() => {
    const theme = localStorage.getItem("Theme") || "dark";
    const body = document.body;
    if (theme === "light") {
      setCurrentTheme("light");
      body.classList.remove("dark");
    } else if (theme === "dark") {
      setCurrentTheme("dark");
      body.classList.add("dark");
    }
    getTheme();
  }, [currentTheme]);

  async function setAppTheme(mode) {
    setCurrentTheme(mode);
    // UPDATE_USER_THEME(mode);
  }

  function getThemeName() {
    
    return currentTheme;
  }

  function getTheme() {
    if (currentTheme.includes("system")) {
      const systemTheme = "light";

      if (systemTheme == "light") {
        return getColorTheme("light");
      } else {
        return getColorTheme("dark");
      }
    } else if (currentTheme == "light") {
      return getColorTheme("light");
    } else if (currentTheme == "dark") {
      return getColorTheme("dark");
    }
    // Default fallback
    return getColorTheme("light");
  }

  useEffect(() => {}, [currentTheme]);

  const theme = getTheme();
  return (
    <ThemeContext.Provider
      value={{
        theme,
        currentTheme,
        setCurrentTheme,
        setAppTheme,
        getThemeName,
      }}
    >
      {props.children}
    </ThemeContext.Provider>
  );
};
